export default [{
  path: '/telegramAnswerMessage',
  name: 'telegramAnswerMessage',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/telegramAnswerMessage/index')
}]
